import { render, staticRenderFns } from "./geoshape.vue?vue&type=template&id=49e94894"
import script from "./geoshape.vue?vue&type=script&lang=js"
export * from "./geoshape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports